<script setup>
import { ref, useId } from 'vue'
import { useModalFocus } from '@/composables/useModalFocus.js'

const props = defineProps({
  show: { type: Boolean, required: true },
  title: { type: String, required: true },
  body: { type: String, default: '' },
  confirmLabel: { type: String, default: null },
  cancelLabel: { type: String, default: null },
  confirmVariant: { type: String, default: 'delete' },
  loading: { type: Boolean, default: false },
})

const emit = defineEmits(['confirm', 'cancel'])
const dialog = ref(null)
const id = useId()
const cancel = () => { if (!props.loading) emit('cancel') }
useModalFocus(dialog, () => props.show, cancel)
</script>

<template>
  <Teleport to="body">
    <div v-if="show" class="modal-overlay" @click.self="cancel">
      <div ref="dialog" class="confirm-modal" role="dialog" aria-modal="true" tabindex="-1"
        :aria-labelledby="`${id}-title`" :aria-describedby="body ? `${id}-body` : undefined" :aria-busy="loading">
        <h2 :id="`${id}-title`" class="confirm-modal__title">{{ title }}</h2>
        <div :id="`${id}-body`" class="confirm-modal__body" v-html="body" />
        <div class="confirm-modal__actions">
          <button type="button" class="confirm-btn cancel" :disabled="loading" @click="cancel">
            {{ cancelLabel ?? $t('common.cancel') }}
          </button>
          <button type="button" :class="['confirm-btn', confirmVariant]" :disabled="loading" @click="$emit('confirm')">
            {{ loading ? $t('common.working') : (confirmLabel ?? $t('common.delete')) }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>
